import Quill, { Parchment } from 'quill/core';
import { isPrecedingCharAllowed } from '../editor/PrefixListener';

export const insertText = (quill: Quill, text: string) => {
  const { index, length } = quill.getSelection(true);
  quill.insertText(index + length, text, Quill.sources.USER);
  quill.setSelection(index + length + text.length, 0, Quill.sources.USER);
};

export const insertPrefix = (quill: Quill, prefix: string) => {
  const { index, length } = quill.getSelection(true);
  const targetIndex = index + length;
  const [leaf, offset] = quill.getLeaf(targetIndex);

  if (leaf instanceof Parchment.TextBlot) {
    const char = leaf.value()[offset - 1];
    if (!isPrecedingCharAllowed(char)) {
      insertText(quill, ` ${prefix}`);
      return;
    }
  }
  insertText(quill, prefix);
};
